import { Injectable } from '@angular/core';
import { Recommendation } from 'src/app/shared/models/recommendation.model';
import { SavvasLinkGeneratorService } from '../link-generators-v2/savvas-link-generator.service';
import { AppNavV2 } from 'src/app/shared/models/app-nav-v2.model';

@Injectable({
  providedIn: 'root'
})
export class AppNavSavvasLinkingService {
  constructor(
    private savvasLinkGeneratorService: SavvasLinkGeneratorService
  ) { }

  public navigateToSavvas(appNavItem: AppNavV2, recommendation?: Recommendation) {
    const skillId = recommendation?.skillMetadata?.rlSkillId ? [recommendation.skillMetadata.rlSkillId] : undefined;

    if (skillId) {
      this.savvasLinkGeneratorService.appLaunch(skillId);
      return;
    }

    this.savvasLinkGeneratorService.appLaunch();
  }
}
